import React, { useState, useEffect } from "react";
import styles from "../assets/css/Modal.module.css";
import { motion } from "framer-motion";

export default function Modal({ onClose, setAutorizaciones }) {
  const [form, setForm] = useState({
    paciente: "",
    tipo: "Autorización",
    motivo: "",
  });

  // 🟢 Detectar la tecla ESC para cerrar el modal
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup al desmontar el componente
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch("http://localhost:8000/api/autorizaciones/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    })
      .then((res) => res.json())
      .then((newAutorizacion) => {
        setAutorizaciones((prev) => [...prev, newAutorizacion]);
        onClose(); // ✅ Cierra modal tras enviar correctamente
      })
      .catch((err) => {
        console.error("Error al enviar la solicitud:", err);
        onClose(); // ✅ También lo cerramos si falla
      });
  };

  return (
    <motion.div
      className={styles.overlay}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      onClick={onClose} // ✅ Cierra modal si clic fuera
    >
      <motion.div
        className={styles.modal}
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        onClick={(e) => e.stopPropagation()} // ✅ Evita cierre al hacer clic dentro
      >
        <h3>Nueva Solicitud</h3>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Nombre del paciente"
            value={form.paciente}
            onChange={(e) => setForm({ ...form, paciente: e.target.value })}
            required
          />

          <select
            value={form.tipo}
            onChange={(e) => setForm({ ...form, tipo: e.target.value })}
          >
            <option value="Autorización">Autorización</option>
            <option value="Cancelación">Cancelación</option>
          </select>

          <textarea
            placeholder="Motivo"
            value={form.motivo}
            onChange={(e) => setForm({ ...form, motivo: e.target.value })}
            required
          />

          <div className={styles.actions}>
            <button type="submit">Enviar</button>
            <button
              type="button"
              onClick={onClose} // ✅ Botón cancelar cierra modal
              className={styles.cancel}
            >
              Cancelar
            </button>
          </div>
        </form>
      </motion.div>
    </motion.div>
  );
}
